<template>
  <b-card-body>
    <b-form submit.stop.prevent="salvar">
      <div class="row1">
        <b-form-group label="Insumo:" label-for="insumoName">
          <b-form-input id="insumoName" type="text" name="validateInsumo" class="inputText input-pentagro"
            v-model="material.description" v-validate="{ required: true }" :state="validateState('validateInsumo')"
            title="Campo para informar o nome do insumo" alt="Campo para informar o nome do insumo"
            aria-describedby="validateInsumo-feedback" data-vv-as="insumo" placeholder="Informe o Insumo ..." />
          <b-form-invalid-feedback id="validateInsumo-feedback">{{
            veeErrors.first("validateInsumo")
          }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Selecione Área de Processo:" label-for="selectprocessarea">
          <b-form-select id="selectprocessarea" name="validateProcessArea" class="inputText input-pentagro"
            v-model="material.processArea" v-validate="{ required: true }" :state="validateState('validateProcessArea')"
            aria-describedby="validateProcessArea-feedback" data-vv-as="área de processo"
            title="Campo para selecionar a área de processo do insumo"
            alt="Campo para selecionar a área de processo do insumo" placeholder="Informe a área de processo ...">
            <b-form-select-option :value="null" disabled>Selecione a área de processo ...</b-form-select-option>
            <b-form-select-option v-for="area in processAreas" :key="area" :value="area">{{ area }}</b-form-select-option>
          </b-form-select>
          <b-form-invalid-feedback id="validateProcessArea-feedback">{{
            veeErrors.first("validateProcessArea")
          }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Código SAP:" label-for="CodSap">
          <b-form-input id="CodSap" type="text" name="validateCodSap" class="inputText input-pentagro"
            v-model="material.erpId" v-validate="{ required: true }" :state="validateState('validateCodSap')"
            title="Campo para informar o código SAP do insumo" alt="Campo para informar o código SAP do insumo"
            aria-describedby="validateCodSap-feedback" data-vv-as="código SAP" placeholder="Informe o Código SAP ..." />
          <b-form-invalid-feedback id="validateCodSap-feedback">
            {{ veeErrors.first("validateCodSap") }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Sequence:" label-for="sequence">
          <b-form-input id="sequence" type="number" name="validateSequence" class="inputText input-pentagro"
            v-model="material.sequence" v-validate="{ required: true }" :state="validateState('validateSequence')"
            title="Campo para informar a sequência do insumo" alt="Campo para informar a sequência do insumo"
            aria-describedby="validateSequence-feedback" data-vv-as="sequence" placeholder="Informe a sequencia..." />
          <b-form-invalid-feedback id="validateSequence-feedback">{{
            veeErrors.first("validateSequence")
          }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Unidade de Medida:" label-for="unitbase">
          <b-form-input id="unitbase" type="text" name="validateunit" class="inputText input-pentagro"
            v-model="material.unit" v-validate="{ required: true }" :state="validateState('validateunit')"
            title="Campo para informar a unidade de medida do insumo"
            alt="Campo para informar a unidade de medida do insumo" aria-describedby="validateunit-feedback"
            data-vv-as="unidade" placeholder="Informe a Unidade ..." />
          <b-form-invalid-feedback id="validateunit-feedback">{{
            veeErrors.first("validateunit")
          }}</b-form-invalid-feedback>
        </b-form-group>
      </div>

      <div class="row2">
        <b-form-group label="Unidade de Consumo Específico:" label-for="specifcUnit">
          <b-form-input id="specifcUnit" type="text" name="validatespecifcUnit" class="inputText input-pentagro"
            v-model="material.specifcUnit" v-validate="{ required: true }" :state="validateState('validatespecifcUnit')"
            aria-describedby="validatespecifcUnit-feedback" data-vv-as="unid. cons. específico"
            title="Campo para informar a unidade de medida do insumo para lista técnica"
            alt="Campo para informar a unidade de medida do insumo para lista técnica"
            placeholder="Informe o Unid. Cons. Especifico ..." />
          <b-form-invalid-feedback id="validatespecifcUnit-feedback">{{
            veeErrors.first("validatespecifcUnit")
          }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group :class="{ span: !this.material.lt }" label="Selecione a Variável:" label-for="selectVar">
          <b-form-select id="selectVar" name="validateVar" class="inputText input-pentagro"
            v-model="material.productionPlanItemId" v-validate="{ required: true }" :state="validateState('validateVar')"
            title="Campo para selecionar a variável plano de safra do insumo para lista técnica"
            alt="Campo para selecionar a variável plano de safra do insumo para lista técnica"
            aria-describedby="validateVar-feedback" data-vv-as="variável" placeholder="Informe a Variável ...">
            <b-form-select-option :value="null" disabled>Selecione a Variável ...</b-form-select-option>
            <b-form-select-option v-for="area in productPlanList" :key="area.sequence" :value="area.id">{{ area.name
            }}</b-form-select-option>
          </b-form-select>
          <b-form-invalid-feedback id="validateVar-feedback">{{
            veeErrors.first("validateVar")
          }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Selecione Área da LT:" label-for="selectltarea" v-if="material.lt" class="inputText"
          id="inputArea">
          <b-form-select id="selectltarea" name="validateLtArea" class="input-pentagro" v-model="material.ltArea"
            v-validate="{ required: this.material.lt ? true : false }" :state="validateState('validateLtArea')"
            aria-describedby="validateLtArea-feedback" data-vv-as="área da LT"
            title="Campo para selecionar a área da lista técnica que o insumo irá ficar"
            alt="Campo para selecionar a área da lista técnica que o insumo irá ficar"
            placeholder="Informe a área da LT ...">
            <b-form-select-option :value="null" disabled>Selecione a área da LT...</b-form-select-option>
            <b-form-select-option v-for="option in ltAreas" :key="option" :value="option">{{ option
            }}</b-form-select-option>
          </b-form-select>
          <b-form-invalid-feedback id="validateLtArea-feedback">{{
            veeErrors.first("validateLtArea")
          }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Fator Específico LT:" label-for="specificFactor" v-if="material.lt" class="inputText">
          <b-form-input id="specificFactor" type="number" name="specificFactor" class="input-pentagro"
            title="Campo para informar o fator específico que o insumo será multiplicado na área da lista técnica"
            alt="Campo para informar o fator específico que o insumo será multiplicado na área da lista técnica"
            v-model="material.specificFactor" aria-describedby="specificFactor-feedback" data-vv-as="valor especfico lt"
            placeholder="Informe o fator específico do insumo na LT  ..." />
        </b-form-group>

        <b-form-group label="Unidade do específico da LT:" label-for="unitSpecificFactor" v-if="material.lt"
          class="inputText">
          <b-form-input id="unitSpecificFactor" type="text" name="unitSpecificFactor" class="input-pentagro"
            title="Campo para informar a unidade de medidade do fator específico que apareceerá para o insumo na lista técnica"
            alt="Campo para informar a unidade de medidade do fator específico que apareceerá para o insumo na lista técnica"
            v-model="material.unitSpecificFactor" aria-describedby="unitSpecificFactor-feedback"
            data-vv-as="unidade de medida do valor especfico lt"
            placeholder="Informe a unidade de medida do fator específico do insumo na LT  ..." />
        </b-form-group>
      </div>

      <div class="row3">
        <b-form-group>
          <b-form-checkbox class="colRow3 cursor-pointer" value="1" v-model="material.lt">LT</b-form-checkbox>
        </b-form-group>
      </div>
    </b-form>

    <span class="filter-kpi" title="Filtre por nome do insumo" alt="Filtre por nome do insumo">
      <label for="filter-kpi">{{ $t('filtro') }}</label>
      <input type="text" name="filter-kpi" class="ml-1 sample1-filter-input" v-model="filter" placeholder="Nome" />
    </span>

    <div class="tableSection">
      <b-row v-if="loaded" class="rowDistance">
        <b-col class="table-responsive-md table-wrapper-scroll-y my-custom-scrollbar">
          <table class="table table-hover table-sm">
            <thead class="thead-dark">
              <th scope="col">Sequencia</th>
              <th scope="col">CÓD. SAP</th>
              <th scope="col">INSUMO</th>
              <th scope="col" style="text-align: center">UNIDADE</th>
              <th scope="col" tyle="text-align: center">VARIÁVEL DO PLANO DE SAFRA</th>
              <th scope="col" style="text-align: center">AÇÕES</th>
            </thead>
            <template v-if="this.filteredItensList.length == 0">Sem dados para visualização<br></template>
            <tbody v-else>
              <tr v-for="item in this.filteredItensList" :key="item.id">
                <td class="text-truncate tableTxt" style="min-width: 25px; max-width: 25px; text-overflow: ellipsis">
                  {{ item.sequence }}
                </td>
                <td class="text-truncate tableTxt" style="min-width: 100px; max-width: 100px; text-overflow: ellipsis">
                  {{ item.erpId }}
                </td>
                <td class="text-truncate tableTxt" style="min-width: 200px; text-overflow: ellipsis">
                  {{ item.description }}
                </td>
                <td class="text-truncate tableTxt" style="min-width: 100px; text-align: center">
                  {{ item.unit }}
                </td>
                <td class="text-truncate tableTxt" style="min-width: 260px; text-overflow: ellipsis">
                  {{ productPlanList.find(x => x.id === item.productionPlanItemid) ? productPlanList.find(x => x.id ===
                    item.productionPlanItemid).name : null }}
                </td>
                <td class="text-truncate tableTxt imgTd">
                  <img class="cursor-pointer" src="@/assets/editar.png" title="Editar Variavel" alt="Editar Variavel"
                    style="margin-left: 3px; height: 15px; width:15px;" @click="editMaterialInput(item.id)" />
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <b-row v-else class="waitTxt rowDistance">Aguardando banco de dados ...</b-row>
    </div>

    <b-row class="groupBtn">
      <div>
        <img id="" class="cursor-pointer" src="@/assets/salvar.png" style="margin-left: 30px;   max-height: 35px;"
          :title="$t('salvar')" alt="Salvar" @click="salvar()" />
        <img id="" class="cursor-pointer" src="@/assets/cancel.png" style="margin-left: 30px;   max-height: 35px;"
          :title="$t('cancelar')" alt="cancelar" @click="eraseForm()" />
      </div>
    </b-row>
  </b-card-body>
</template>

<script>
import { urlMainAPI, defaultSuccess, showError } from "@/global";
import axios from "axios";

export default {
  name: "registerInputsEditor",

  watch: {
    filter(value) {
      if (value == "") this.filteredItensList = this.inputsList;
      else
        this.filteredItensList = this.inputsList.filter(
          (d) =>
            d.description.toUpperCase().includes(value.toUpperCase())
        );
    }
  },

  data() {
    return {
      optionsplanitem: false,
      optionsgroup: [],
      processAreas: [],
      ltAreas: [],
      material: {
        id: 0,
        erpId: "",
        description: "",
        unit: "",
        specifcUnit: "",
        productionPlanItemId: null,
        processArea: null,
        ltArea: null,
        lt: 0,
        specificFactor: "",
        unitSpecificFactor: ""
      },
      productPlanList: [],
      inputsList: [],
      filteredItensList: [],
      loaded: false,
      filter: null
    };
  },
  methods: {

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },

    async loadProductioPlanItensList() {
      const url = `${urlMainAPI}/getproductionplanitemlist`;
      await axios
        .get(url)
        .then((res) => {
          this.productPlanList = res.data
        })
        .catch();
      this.processAreas = new Set(this.productPlanList.map(x => x.processArea).filter(x => x != null && x != "").sort())
      this.ltAreas = new Set(this.productPlanList.map(x => x.ltArea).filter(x => x != null && x != "").sort())

      this.productPlanList.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
    },

    async loadMaterialInputsList() {
      const url = `${urlMainAPI}/getmaterialinputlist`;
      await axios
        .get(url)
        .then((res) => {
          this.inputsList = res.data;
          this.filteredItensList = this.inputsList;
          this.loaded = true
        })
        .catch();
    },

    editMaterialInput(id) {
      defaultSuccess(this.$t('carregando-dados-do-insumo'))
      const url = `${urlMainAPI}/getmaterialinput/${id}`;
      axios
        .get(url)
        .then((res) => {
          this.material = res.data;
        })
        .catch();
    },

    eraseForm() {
      let materialtemp = {
        id: 0,
        name: "",
        sequence: null,
        erpId: "",
        description: "",
        unit: "",
        specifcUnit: "",
        productionPlanItemId: null,
        processArea: null,
        ltArea: null,
        lt: 0,
        specificFactor: "",
        unitSpecificFactor: ""
      }
      this.material = materialtemp;
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },

    salvar() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          showError(this.$t('campos-com-preenchimento-obrigatorio'));
          return;
        }

        let index
        let itemConflit = this.inputsList.find((item, i) => {
          if (item.sequence == this.material.sequence) {
            index = i
            return true
          }
        })
        if (itemConflit && itemConflit.description != this.inputsList[index].description) {
          showError(this.$t('sequencia') + `${itemConflit.sequence} ` + this.$t('ja-existente-item') + `${itemConflit.description}`)
          return false
        }

        this.material.lt = this.material.lt == 1 ? 1 : 0
        this.material.ltArea = this.material.lt == 1 ? this.material.ltArea : null
        const url = `${urlMainAPI}/savematerialinput`
        axios
          .post(url, this.material)
          .then((res) => {
            if (res) {
              defaultSuccess(res.data);
              this.eraseForm();
              this.loadMaterialInputsList();
            }
          })
          .catch();
      })
    }
  },
  async created() {
    await this.loadProductioPlanItensList();
    this.loadMaterialInputsList();
    this.$validator.localize("pt_BR");
  },
  beforeDestroy() {

  }
};
</script>

<style scoped>
form {
  display: grid;
  grid-template-rows: 95px 95px 25px;
}

.row1,
.row2 {
  display: grid;
  grid-row-start: 1;
  grid-template-columns: repeat(5, 1fr);
}

.row1>div,
.row2>div {
  padding: 0 5px;
}

.row2 {
  grid-row-start: 2;
}

.span {
  grid-column-start: 2;
  grid-column-end: span 2;
}

.cursor-pointer:hover {
  cursor: pointer;
}

.inputText {
  min-width: 231px;
}

#inputArea {
  margin-right: 0.2rem;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

.colRow3 {
  display: flex;
  justify-content: flex-end;
}

table {
  border-collapse: initial;
  border-spacing: initial;
}

.my-custom-scrollbar {
  max-height: 210px;
  overflow: auto;
  margin: 0px auto;
  padding-left: 0px;
  padding-right: 0px;
}

.my-custom-scrollbar th {
  position: sticky;
  top: 0;
}

.waitTxt {
  justify-content: center;
  background: black;
  color: white;
  margin: 10px auto;
  min-width: 300px;
  max-width: 400px;
}

.tableSection {
  margin: 15px;
}

.imgTd {
  min-width: 100px;
  text-align: center;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-top: 35px;
  margin-right: 5px;
}

@media only screen and (max-width: 1366px) {

  .row1,
  .row2 {
    display: grid;
    grid-row-start: 1;
    grid-template-rows: repeat(2, 90px);
    grid-template-columns: repeat(5, 1fr);
  }

  .row2 {
    grid-row-start: 2;
  }

  .span {
    grid-column-start: 2;
    grid-column-end: span 2;
  }
}

@media only screen and (max-width: 1040px) {
  form {
    display: grid;
    grid-template-rows: repeat(2, 170px);
  }

  .row1,
  .row2 {
    display: grid;
    grid-row-start: 1;
    grid-template-rows: repeat(2, 90px);
    grid-template-columns: repeat(2, 1fr);
  }

  .row1>div,
  .row2>div {
    padding: 0 5px;
  }

  .row2 {
    grid-row-start: 3;
  }

  .span {
    grid-column-start: 2;
    grid-column-end: span 3;
  }
}

@media only screen and (max-width: 810px) {
  form {
    display: block;
  }

  .row1,
  .row2,
  .row1_1 {
    display: flex;
    flex-wrap: wrap;
  }

  .inputText,
  .colRow3 {
    width: calc(100vw - 80px);
  }

  .inputTextLt {
    width: 100%;
  }
}
</style>
